import request from './request.js';

// 获取平台信息
export function getPartnerInfo(params) {
  return request({
    url: '/api/v1/user/company/details.json',
    method: 'get',
    params,
  });
}

// 获取软件平台包列表
export function getPlatformList(data) {
  return request({
    url: '/api/v1/version/gray/auth/lists.json',
    method: 'post',
    data,
  });
}
